import { render } from "./companies.vue?vue&type=template&id=245d05b6&ts=true"
import script from "./companies.vue?vue&type=script&lang=ts"
export * from "./companies.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__